import { exhaustMap } from 'rxjs';
import { inject } from '@angular/core';
import { VesselSpecService } from '@navstation-portal/vessels/data-access/service';
import { VesselSpecStoreState } from '@navstation-portal/vessels/data-model/vessel';
import { mapResponse } from '@ngrx/operators';
import { signalStoreFeature, type } from '@ngrx/signals';
import { Events, withEventHandlers } from '@ngrx/signals/events';
import { vesselSpecEvents } from './vessel-spec-events';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function withVesselSpecEffects<_>() {
  return signalStoreFeature(
    type<{ state: VesselSpecStoreState }>(),
    withEventHandlers(() => {
      const events = inject(Events);
      const vesselSpecService = inject(VesselSpecService);

      return {
        fetchVesselSpec$: events.on(vesselSpecEvents.fetchVesselSpec).pipe(
          exhaustMap(({ payload: vesselId }) =>
            vesselSpecService.getVesselSpec(vesselId).pipe(
              mapResponse({
                next: (vesselSpec) => vesselSpecEvents.fetchVesselSpecSuccess(vesselSpec),
                error: (err: Error) => vesselSpecEvents.fetchVesselSpecFailed(err),
              })
            )
          )
        ),
        updateVesselSpec$: events.on(vesselSpecEvents.updateVesselSpec).pipe(
          exhaustMap(({ payload: { vesselId, body } }) =>
            vesselSpecService.updateVesselSpec(vesselId, body).pipe(
              mapResponse({
                next: () => vesselSpecEvents.updateVesselSpecSuccess(),
                error: (err: Error) => vesselSpecEvents.updateVesselSpecFailed(err),
              })
            )
          )
        ),
      };
    })
  );
}
